'use strict';

const {WarehouseProductAdditionalInformation, WarehouseLevel, ProductUnit} = require('../../custom_components/js/warehouse/client/WarehouseLevel');
const {AddProductToLevelRequest} = require('../directives/warehouse/client/level/AddProductToLevelRequest');
const {ProductSearchResult, PaginationResponse} = require('../../custom_components/js/warehouse/client/Product')

module.exports = (app) => app.factory('clientWarehouseService', /* @ngInject */ function (apiConfig, httpService) {
    function getAllEmptyLevels() {
        const uri = apiConfig.getBase('customer', 'warehouse', 'storage', 'empty');

        return httpService.get(uri.toString(), {
            isArray: true,
            transformResponse: (response) => convertLevels(response)
        })
    }

    function stockReceiptItem(receiptId, receiptItemId, stockedQuantity) {
        const uri = apiConfig.getBase('delivery-receipt', receiptId, 'item', receiptItemId, 'stock');
        uri.query.quantityStocked = stockedQuantity;

        return httpService.post(uri.toString(), {});
    }

    /**
     *
     * @param addProductToLevelRequest {AddProductToLevelRequest}
     */
    function addProductToLevel(addProductToLevelRequest) {
        const uri = apiConfig.getBase('customer', 'warehouse', addProductToLevelRequest.levelId, 'add-product');

        return httpService.post(uri.toString(), addProductToLevelRequest);
    }

    function getStoragesBySearchQuery(query) {
        const uri = apiConfig.getBase('customer', 'warehouse', 'product', 'search');
        uri.query.searchQuery = query;
        uri.query.limit = 50;

        return httpService.get(uri.toString(), {
            isArray: true,
            transformResponse: (response) => convertLevels(response)
        })
    }

    function searchBySupplierIdAndSupplierArticleNumber(supplierId, supplierArticleNumber) {
        if(supplierId && supplierArticleNumber) {
            const uri = apiConfig.getBase('customer', 'warehouse', 'product', 'match');
            uri.query = {
                [WarehouseProductAdditionalInformation.DTO_KEY.supplierId]: supplierId,
                [WarehouseProductAdditionalInformation.DTO_KEY.supplierArticleNumber]: supplierArticleNumber,
            }

            return httpService.get(uri.toString(), {
                isArray: true,
                transformResponse: (response) => convertLevels(response)
            })
        }

        return Promise.resolve([]);
    }

    /**
     * Add quantity to an existing storage at a specific level
     * @param levelId {string}
     * @param quantity {number}
     * @param units {ProductUnit}
     * @param orderItemId {number}
     * @param remark {string}
     * @return {Promise<void>}
     */
    function stockToExistingStorage(levelId, quantity, units, orderItemId, remark) {
        const uri = apiConfig.getBase('customer', 'warehouse', 'level', levelId, 'storage', 'add');

        const data = {
            orderItemId,
            amount: quantity,
            remark,
            unit: units
        }

        return httpService.put(uri.toString(), data);
    }

    /**
     * @param query {string}
     * @param page {number}
     * @param elementsPerPage {number}
     */
    function searchProducts(query, page, elementsPerPage) {
        const uri = apiConfig.getBase('customer', 'warehouse', 'search', 'global');

        uri.query.searchString = query;
        uri.query.page = page;
        uri.query.elementsPerPage = elementsPerPage;

        return httpService.get(uri.toString(), {
            transformResponse: (result) => {
                const parsed = JSON.parse(result);
                return new PaginationResponse(parsed.data, parsed.pagination)
            }
        })
    }

    function convertLevels(data) {
        try {
            const levelDtos = JSON.parse(data);
            if(levelDtos && Array.isArray(levelDtos)) {
                return levelDtos.map(levelDto => new WarehouseLevel(levelDto)).sort((a,b) => {
                    if(a.sortingIdentifier > b.sortingIdentifier) {
                        return 1;
                    }
                    if(a.sortingIdentifier < b.sortingIdentifier) {
                        return -1
                    }

                    return 0;
                });
            }

            return [];
        } catch (e) {
            console.error(e);
            return [];
        }
    }

    return {
        /**
         * @returns {Promise<WarehouseLevel[]>}
         */
        getAllEmptyLevels,

        /**
         * @returns {Promise<WarehouseLevel[]>}
         */
        searchBySupplierIdAndSupplierArticleNumber,

        /**
         * @returns {Promise<WarehouseLevel[]>}
         */
        getStoragesBySearchQuery,

        /**
         * @returns {Promise<void>}
         */
        addProductToLevel,

        /**
         * @returns {Promise<void>}
         */
        stockReceiptItem,

        /**
         * @returns {Promise<void>}
         */
        stockToExistingStorage,

        /**
         * @returns {Promise<ProductSearchResult[]>}
         */
        searchProducts
    }
});
